// used by the Assessment page and the assessments reports
import React from "react"
import dayjs from "dayjs"
import _ from "lodash"
import EmbeddedRowsCell from "components/grids/EmbeddedRowsCell/EmbeddedRowsCell"
// @ts-ignore
import { DateBadge } from "components-design-system"
import "./ActivityCompletionDatesCell.scss"

// utils
// @ts-ignore
import { useUserSettings } from "api/hooks"

type ActivityCompletionDatesCellProps = {
  completionDateKey: string
  completionDateTypeKey: string
  activities: {
    [key: string]: string
  }[]
}

const ActivityCompletionDatesCell = ({
  activities,
  completionDateKey,
  completionDateTypeKey,
}: ActivityCompletionDatesCellProps) => {
  const { data: userSettings } = useUserSettings()
  const dateFormat = userSettings?.date_format ? userSettings.date_format : "DD-MM-YYYY"

  return (
    <EmbeddedRowsCell className="activity-completion-date-cell">
      {activities.map((activity) => (
        <EmbeddedRowsCell.Cell
          key={`${activity[completionDateKey]}-${activity[completionDateTypeKey]}`}
          className="activity-table-cell"
        >
          {activity?.completion_date_type && (
            <DateBadge
              badgeType={_.capitalize(activity[completionDateTypeKey])}
              date={dayjs(activity[completionDateKey]).format(dateFormat)}
            />
          )}
        </EmbeddedRowsCell.Cell>
      ))}
    </EmbeddedRowsCell>
  )
}

export default ActivityCompletionDatesCell
